import {useQuery} from 'react-query'
import {getAPi} from '../service'
import {dataToMultiSelectOptions} from '../utils'

export const useGetUniqueClassifications = () => {
  const {data: response = [], isFetching} = useQuery('get-Product-Classifications', () =>
    getAPi(`/analytics/replenishment/unique/classifications`)
  )
  return {
    Classifications: dataToMultiSelectOptions(response),
    ClassificationsLoading: isFetching,
  }
}
